<template>
  <v-menu
    v-model="open"
    :close-on-content-click="true"
    transition="slide-y-transition"
    offset-y
    nudge-top="-6"
    bottom
    class="menu-setting"
  >
    <template #activator="{ on }">
      <div class="setting">
        <v-btn
          color="primary"
          fab
          text
          small
          v-on="on"
          class="ma-1"
          :aria-label="$t('lang.header_language')"
          :title="$t('lang.header_language')"
        >
          <v-icon :class="{ invert: invert, active: open }" class="icon" color="primary">
            mdi-translate
          </v-icon>
        </v-btn>
      </div>
    </template>
    <div class="popover violeta-var">
      <v-list class="lang-menu">
        <v-list-item
          v-for="locale in $i18n.locales"
          :key="locale.code"
          class="lang-list"
          :class="{ 'lang-list--active': locale.code === $i18n.locale }"
          @click="switchLang(locale.code)"
        >
          <v-list-item-avatar class="flag">
            <i :class="locale.code" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="lang-opt">
              {{ $t('lang.' + locale.code) }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action-text class="lang-code">
            {{ String(locale.code).toUpperCase() }}
          </v-list-item-action-text>
          <v-list-item-action>
            <v-icon v-if="locale.code === $i18n.locale" color="primary">
              mdi-check
            </v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </div>
  </v-menu>
</template>

<style lang="scss" scoped>
@import '../header-style.scss';

.lang-list {
  border-radius: 10px;
  margin: 2px 6px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(63, 81, 181, 0.08);
  }
}

.lang-list--active {
  background: rgba(63, 81, 181, 0.12);

  .lang-opt {
    color: #3f51b5;
    font-weight: 700;
  }
}

.lang-opt {
  font-weight: 600;
}

.lang-code {
  font-size: 0.72rem;
  letter-spacing: 0.5px;
  color: rgba(0, 0, 0, 0.45);
  margin-right: 2px;
}
</style>

<script>
export default {
  props: {
    invert: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    open: false
  }),
  methods: {
    switchLang: function (val) {
      if (val === this.$i18n.locale) {
        this.open = false
        return
      }

      this.$i18n.setLocale(val)
      this.open = false
    }
  }
}
</script>
